module.exports = __webpack_public_path__ + "img/SAMT_white.f306cd80.svg";